import jexl from "jexl";
import unescape from "lodash.unescape";
import { IFormModel } from "@cayo/shared/components/Form/modelUtils/types";
import { generationRuleFunctionRegistry } from "./generation-rule-utils";

const generationRuleRegExps = {
  generationRule: /{{([\s\S]+?)}}/,
  multipleProperties: /}}.+{{/,
  curlyBrackets: /}}|{{/g,
};

const cache = new Map<string, string>();

jexl.addFunctions(generationRuleFunctionRegistry);

export const parseGenerationRule = (expr: string, model?: IFormModel): string => {
  if (!expr) {
    return "";
  }

  let templateFunction: string = ``;

  if (cache.has(expr)) {
    templateFunction = cache.get(expr)!;
  } else {
    const { generationRule, multipleProperties, curlyBrackets } = generationRuleRegExps;

    // remove opening "{{"" and closing "}}"
    if (generationRule.test(expr)) {
      templateFunction = unescape(expr.slice(2, -2));
    }

    // in case of "{{GivenName}} {{Surname}}" generation rules
    if (multipleProperties.test(expr)) {
      const properties = expr.replace(curlyBrackets, "").split(" ");
      templateFunction = `GJoinByChar([${properties}],' ')`;
    }

    cache.set(expr, templateFunction);
  }

  return jexl.evalSync(templateFunction, model);
};
